"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCreditAgreementShell = exports.getPartyShell = exports.createVerificationAgentShell = exports.createServicerShell = exports.createPayingAgentShell = exports.createCollectionAccountBankShell = exports.createBackupServicerShell = exports.createAdminAgentShell = exports.createCapitalProviderRepresentativeShell = exports.createCapitalProviderShell = exports.createBorrowerShell = exports.getPropertyShell = exports.createOvercollateralizationMethodPropertyShell = exports.createOvercollateralizationAmountPropertyShell = exports.createTextPropertyShell = exports.createRecurringDatePropertyShell = exports.createReportTypePropertyShell = exports.createPercentageRatePropertyShell = exports.createNumberPropertyShell = exports.createMaximumPrefundingAmountPropertyShell = exports.createLinkedAccountPropertyShell = exports.createAutoApprovalPropertyShell = exports.createInterestRateBenchmarkPropertyShell = exports.createFrequencyPropertyShell = exports.createFrequencyPeriodPropertyShell = exports.createDatePropertyShell = exports.createCurrencyPropertyShell = exports.createClassAllocationMethodPropertyShell = exports.createBooleanPropertyShell = exports.createBankAccountTypePropertyShell = void 0;
const lodash_1 = __importDefault(require("lodash"));
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const createBankAccountTypePropertyShell = (propertyKey) => ({
    name: lodash_1.default.startCase(propertyKey),
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.BankAccountTypeProperty,
    value: finley_types_1.Bank.BorrowerAccountType.ParentOperatingAccount,
    _isWrittenIn_: true,
});
exports.createBankAccountTypePropertyShell = createBankAccountTypePropertyShell;
const createBooleanPropertyShell = (propertyKey) => ({
    name: lodash_1.default.startCase(propertyKey),
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.BooleanProperty,
    value: true,
    _isWrittenIn_: true,
});
exports.createBooleanPropertyShell = createBooleanPropertyShell;
const createClassAllocationMethodPropertyShell = (propertyKey) => ({
    name: lodash_1.default.startCase(propertyKey),
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.ClassAllocationMethodProperty,
    value: finley_types_1.FundingRequest.ClassDrawRequestAllocationMethod
        .FixedAttachmentRateLimitProportion,
    _isWrittenIn_: true,
});
exports.createClassAllocationMethodPropertyShell = createClassAllocationMethodPropertyShell;
const createCurrencyPropertyShell = (propertyKey) => ({
    name: lodash_1.default.startCase(propertyKey),
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.CurrencyProperty,
    value: 0,
    currency: finley_types_1.Bank.Currency.USD,
    _isWrittenIn_: true,
});
exports.createCurrencyPropertyShell = createCurrencyPropertyShell;
const createDatePropertyShell = (propertyKey) => ({
    name: lodash_1.default.startCase(propertyKey),
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.DateProperty,
    value: '2022-01-01',
    _isWrittenIn_: true,
});
exports.createDatePropertyShell = createDatePropertyShell;
const createFrequencyPeriodPropertyShell = (propertyKey) => ({
    name: lodash_1.default.startCase(propertyKey),
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.FrequencyPeriodProperty,
    value: finley_types_1.CreditAgreement.FrequencyPeriod.Month,
    _isWrittenIn_: true,
});
exports.createFrequencyPeriodPropertyShell = createFrequencyPeriodPropertyShell;
const createFrequencyPropertyShell = (propertyKey) => ({
    name: lodash_1.default.startCase(propertyKey),
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.FrequencyProperty,
    value: 1,
    frequencyPeriod: finley_types_1.CreditAgreement.FrequencyPeriod.Week,
    frequencyType: finley_types_1.CreditAgreement.FrequencyType.Calendar,
    _isWrittenIn_: true,
});
exports.createFrequencyPropertyShell = createFrequencyPropertyShell;
const createInterestRateBenchmarkPropertyShell = (propertyKey) => ({
    name: lodash_1.default.startCase(propertyKey),
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.InterestRateBenchmarkProperty,
    value: finley_types_1.Bank.InterestRateBenchmark.LIBOR1M,
    _isWrittenIn_: true,
});
exports.createInterestRateBenchmarkPropertyShell = createInterestRateBenchmarkPropertyShell;
const createAutoApprovalPropertyShell = (propertyKey) => ({
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.AutoApprovalProperty,
    value: 17,
    unit: finley_types_1.CreditAgreement.DomainEntity.NumberPropertyUnit.Hour24,
    approvalStrategy: finley_types_1.CreditAgreement.DomainEntity.AutoApprovalStrategy.SpecificHour,
    name: lodash_1.default.startCase(propertyKey),
    _isWrittenIn_: true,
});
exports.createAutoApprovalPropertyShell = createAutoApprovalPropertyShell;
const createLinkedAccountPropertyShell = () => ({
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.LinkedAccountProperty,
    value: 'placeholderAccountId',
    name: 'Bank Account',
    _isWrittenIn_: true,
});
exports.createLinkedAccountPropertyShell = createLinkedAccountPropertyShell;
const createMaximumPrefundingAmountPropertyShell = (propertyKey) => ({
    _isWrittenIn_: true,
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.MaximumPrefundingAmountProperty,
    name: lodash_1.default.startCase(propertyKey),
    value: 'placeholder',
    _config_: {
        maximumPrefundingAmountConfig: {
            type: 'formula',
            config: {
                engineVersion: finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1,
                formula: '0',
            },
        },
    },
});
exports.createMaximumPrefundingAmountPropertyShell = createMaximumPrefundingAmountPropertyShell;
const createNumberPropertyShell = (propertyKey) => ({
    name: lodash_1.default.startCase(propertyKey),
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.NumberProperty,
    unit: finley_types_1.CreditAgreement.DomainEntity.NumberPropertyUnit.BusinessDay,
    value: 0,
    _isWrittenIn_: true,
});
exports.createNumberPropertyShell = createNumberPropertyShell;
const createPercentageRatePropertyShell = (propertyKey) => ({
    name: lodash_1.default.startCase(propertyKey),
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.PercentageRateProperty,
    value: 0,
    _isWrittenIn_: true,
});
exports.createPercentageRatePropertyShell = createPercentageRatePropertyShell;
const createReportTypePropertyShell = () => ({
    name: 'Notice Of Borrowing',
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.ReportTypeProperty,
    value: 'noticeOfBorrowing',
    _isWrittenIn_: true,
});
exports.createReportTypePropertyShell = createReportTypePropertyShell;
const createRecurringDatePropertyShell = () => ({
    name: 'placeholder',
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.RecurringDateProperty,
    value: 'placeholder',
    _isWrittenIn_: true,
    _config_: {
        recurringDateConfig: {
            recurringDateConfigs: [],
            exclusions: [],
        },
    },
});
exports.createRecurringDatePropertyShell = createRecurringDatePropertyShell;
const createTextPropertyShell = (propertyKey) => ({
    name: lodash_1.default.startCase(propertyKey),
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.TextProperty,
    value: 'placeholder',
    _isWrittenIn_: true,
});
exports.createTextPropertyShell = createTextPropertyShell;
const createOvercollateralizationAmountPropertyShell = (propertyKey) => ({
    name: lodash_1.default.startCase(propertyKey),
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType
        .OvercollateralizationAmountProperty,
    value: 0.5,
    valueType: 'percent',
    _isWrittenIn_: true,
});
exports.createOvercollateralizationAmountPropertyShell = createOvercollateralizationAmountPropertyShell;
const createOvercollateralizationMethodPropertyShell = (propertyKey) => ({
    name: lodash_1.default.startCase(propertyKey),
    type: finley_types_1.CreditAgreement.DomainEntity.PropertyType
        .OvercollateralizationMethodProperty,
    value: finley_types_1.CreditAgreement.DomainEntity.OvercollateralizationMethod.ClassSubordination,
    _isWrittenIn_: true,
});
exports.createOvercollateralizationMethodPropertyShell = createOvercollateralizationMethodPropertyShell;
const getPropertyShell = ({ type, propertyKey, }) => {
    switch (type) {
        case 'autoApprovalProperty':
            return (0, exports.createAutoApprovalPropertyShell)(propertyKey);
        case 'bankAccountTypeProperty':
            return (0, exports.createBankAccountTypePropertyShell)(propertyKey);
        case 'booleanProperty':
            return (0, exports.createBooleanPropertyShell)(propertyKey);
        case 'classAllocationMethodProperty':
            return (0, exports.createClassAllocationMethodPropertyShell)(propertyKey);
        case 'currencyProperty':
            return (0, exports.createCurrencyPropertyShell)(propertyKey);
        case 'dateProperty':
            return (0, exports.createDatePropertyShell)(propertyKey);
        case 'frequencyPeriodProperty':
            return (0, exports.createFrequencyPeriodPropertyShell)(propertyKey);
        case 'frequencyProperty':
            return (0, exports.createFrequencyPropertyShell)(propertyKey);
        case 'interestRateBenchmarkProperty':
            return (0, exports.createInterestRateBenchmarkPropertyShell)(propertyKey);
        case 'linkedAccountProperty':
            return (0, exports.createLinkedAccountPropertyShell)();
        case 'maximumPrefundingAmountProperty':
            return (0, exports.createMaximumPrefundingAmountPropertyShell)(propertyKey);
        case 'numberProperty':
            return (0, exports.createNumberPropertyShell)(propertyKey);
        case 'overcollateralizationAmountProperty':
            return (0, exports.createOvercollateralizationAmountPropertyShell)(propertyKey);
        case 'overcollateralizationMethodProperty':
            return (0, exports.createOvercollateralizationMethodPropertyShell)(propertyKey);
        case 'percentageRateProperty':
            return (0, exports.createPercentageRatePropertyShell)(propertyKey);
        case 'recurringDateProperty':
            return (0, exports.createRecurringDatePropertyShell)();
        case 'reportTypeProperty':
            return (0, exports.createReportTypePropertyShell)();
        case 'textProperty':
            return (0, exports.createTextPropertyShell)(propertyKey);
        case 'deliverableReportProperty':
        case 'eligibilityTestProperty':
        case 'classLabelProperty':
            /**
             *  deliverableReportProperty will not be added through the AddPropertyModal, and instead be handled by an onClick handler within section/ReportingDeliverables AddIconButton.
             * DeliverableReportProperty should not be used outside of the ReportingDeliverables section
             */
            throw Error(`unsupported property type ${type}`);
        default:
            throw Error(`unknown property type ${type}`);
    }
};
exports.getPropertyShell = getPropertyShell;
const createBaseEntityShell = (id) => {
    return {
        entity: {
            id,
            name: 'placeholder',
            slug: 'placeholder',
        },
        users: [],
        _isWrittenIn_: true,
    };
};
const createBorrowerShell = (borrowerId, customerType = finley_types_1.CreditAgreement
    .DomainEntity.Items.CustomerType.None) => {
    return {
        ...createBaseEntityShell(borrowerId),
        type: finley_types_1.CreditAgreement.DomainEntity.Items.PartyType.Borrower,
        customerType,
        borrowerEntityName: (0, exports.createTextPropertyShell)('borrowerEntityName'),
        bankAccounts: [],
    };
};
exports.createBorrowerShell = createBorrowerShell;
const createCapitalProviderShell = (organizationId, customerType = finley_types_1.CreditAgreement
    .DomainEntity.Items.CustomerType.None) => {
    return {
        ...createBaseEntityShell(organizationId),
        type: finley_types_1.CreditAgreement.DomainEntity.Items.PartyType.CapitalProvider,
        customerType,
        bankAccounts: [],
        _config_: {
            interestRateBase: finley_types_1.CreditAgreement.DomainEntity.Items.InterestRateBase.Fixed,
        },
        // These properties are required.
        commitmentAmount: (0, exports.createCurrencyPropertyShell)('commitmentAmount'),
        interestRateFixedBase: (0, exports.createPercentageRatePropertyShell)('interestRateFixedBase'),
    };
};
exports.createCapitalProviderShell = createCapitalProviderShell;
const createCapitalProviderRepresentativeShell = (organizationId) => {
    return {
        ...createBaseEntityShell(organizationId),
        type: finley_types_1.CreditAgreement.DomainEntity.Items.PartyType
            .CapitalProviderRepresentative,
        customerType: finley_types_1.CreditAgreement.DomainEntity.Items.CustomerType.None,
    };
};
exports.createCapitalProviderRepresentativeShell = createCapitalProviderRepresentativeShell;
const createAdminAgentShell = (organizationId) => ({
    ...createBaseEntityShell(organizationId),
    type: finley_types_1.CreditAgreement.DomainEntity.Items.PartyType.AdminAgent,
    customerType: finley_types_1.CreditAgreement.DomainEntity.Items.CustomerType.None,
});
exports.createAdminAgentShell = createAdminAgentShell;
const createBackupServicerShell = (organizationId) => ({
    ...createBaseEntityShell(organizationId),
    type: finley_types_1.CreditAgreement.DomainEntity.Items.PartyType.BackupServicer,
    customerType: finley_types_1.CreditAgreement.DomainEntity.Items.CustomerType.None,
});
exports.createBackupServicerShell = createBackupServicerShell;
const createCollectionAccountBankShell = (organizationId) => ({
    ...createBaseEntityShell(organizationId),
    type: finley_types_1.CreditAgreement.DomainEntity.Items.PartyType.CollectionAccountBank,
    customerType: finley_types_1.CreditAgreement.DomainEntity.Items.CustomerType.None,
});
exports.createCollectionAccountBankShell = createCollectionAccountBankShell;
const createPayingAgentShell = (organizationId) => ({
    ...createBaseEntityShell(organizationId),
    type: finley_types_1.CreditAgreement.DomainEntity.Items.PartyType.PayingAgent,
    customerType: finley_types_1.CreditAgreement.DomainEntity.Items.CustomerType.None,
});
exports.createPayingAgentShell = createPayingAgentShell;
const createServicerShell = (organizationId) => ({
    ...createBaseEntityShell(organizationId),
    type: finley_types_1.CreditAgreement.DomainEntity.Items.PartyType.Servicer,
    customerType: finley_types_1.CreditAgreement.DomainEntity.Items.CustomerType.None,
});
exports.createServicerShell = createServicerShell;
const createVerificationAgentShell = (organizationId) => ({
    ...createBaseEntityShell(organizationId),
    type: finley_types_1.CreditAgreement.DomainEntity.Items.PartyType.VerificationAgent,
    customerType: finley_types_1.CreditAgreement.DomainEntity.Items.CustomerType.None,
});
exports.createVerificationAgentShell = createVerificationAgentShell;
const getPartyShell = ({ type, organizationId, }) => {
    switch (type) {
        case 'adminAgent':
            return (0, exports.createAdminAgentShell)(organizationId);
        case 'backupServicer':
            return (0, exports.createBackupServicerShell)(organizationId);
        case 'borrower':
            return (0, exports.createBorrowerShell)(organizationId);
        case 'capitalProvider':
            return (0, exports.createCapitalProviderShell)(organizationId);
        case 'capitalProviderRepresentative':
            return (0, exports.createCapitalProviderRepresentativeShell)(organizationId);
        case 'collectionAccountBank':
            return (0, exports.createCollectionAccountBankShell)(organizationId);
        case 'payingAgent':
            return (0, exports.createPayingAgentShell)(organizationId);
        case 'servicer':
            return (0, exports.createServicerShell)(organizationId);
        case 'verificationAgent':
            return (0, exports.createVerificationAgentShell)(organizationId);
        default:
            throw Error(`unknown party type ${type}`);
    }
};
exports.getPartyShell = getPartyShell;
const createCreditAgreementShell = ({ creditFacilityId, facilityType, }) => {
    return {
        id: (0, uuid_1.v4)(),
        facilityType,
        creditFacilityId,
        effectiveFrom: common_1.date.currentEpochMs(),
        effectiveTo: common_1.consts.MAX_TIMESTAMP,
        version: '0.01',
        _schemaVersion_: common_1.consts.CURRENT_CREDIT_AGREEMENT_DOCUMENT_SCHEMA_VERSION,
        s3Path: '',
        borrowingBaseMechanics: {
            calcAgentMechanics: {
                _config_: { concentrationKickoutMethod: 'waterfall' },
                loanProductMechanics: [],
                multiLoanProductConcentrationLimits: [],
            },
        },
        facilityMechanics: {
            closingDate: (0, exports.createDatePropertyShell)('Closing Date'),
            finalMaturityDate: (0, exports.createDatePropertyShell)('Final Maturity Date'),
            structure: {
                name: 'Structure',
                type: finley_types_1.CreditAgreement.DomainEntity.PropertyType.StructureProperty,
                value: finley_types_1.CreditFacility.CreditFacilityStructureType.FixedProportion,
                _isWrittenIn_: true,
            },
            parties: {
                adminAgents: [],
                backupServicers: [],
                borrowers: [],
                capitalProviders: [],
                capitalProviderRepresentatives: [],
                collectionAccountBanks: [],
                payingAgents: [],
                servicers: [],
                verificationAgents: [],
            },
        },
        fundingRequestMechanics: {
            collectionsPaydown: {},
            collectionsRecycle: {},
            curePaydown: {},
            drawRequest: {},
        },
        settlementMechanics: {},
        financialCovenants: [],
        portfolioCovenants: [],
        reportingDeliverables: [],
        deliverables: [],
        reportingMechanics: [],
    };
};
exports.createCreditAgreementShell = createCreditAgreementShell;
//# sourceMappingURL=creditAgreementShell.js.map